define('global/UI/SetupPackard',[
	'jquery',
	'plugins/jquery.matchHeight'
], function ($) {
    'use strict';


    $(document).click(function (event) {
        // Check if clicked outside .itemButtons
        if (!($(event.target).closest(".itemButtons").length)) {
            // remove class
            $(".itemButtons div").removeClass("in");
            $(".itemButtons .roc-addToCartFavoritesWrapper,.itemButtons li").removeClass("list-open");
            $(".itemButtons button").attr("aria-expanded", "false");
        }
    });

    $(document).ajaxComplete(function (event, request, settings) {
		

        setTimeout(function () {
            $('div[data-sf-role="form-container"]').addClass('formee');
            equalheight('.itemWrapper .productBrand');
            equalheight('#hawkitemlist .itemWrapper .itemImageWrapper');
            equalheight('#hawkitemlist .itemWrapper .itemTitle .itemLink');
            equalheight('#hawkitemlist .itemWrapper .item-brand-id-wrapper');
            equalheight('#hawkitemlist .itemWrapper .itemAction');
        }, 500);

        setTimeout(function () {
            $(".productListInner .itemWrapper").each(function () {
                $(this).find(".hawk-brokenImage").attr("src", "/ResourcePackages/Roc/assets/images/na-images/na-m.jpg");
            });
        }, 1000);
				
		$('.qtyTextBox').each(function() {
			var e = $(this);
			e.on({
				"keydown":function(o) {
					if (o.keyCode===9 || o.keyCode===13 || o.keyCode===32) {
						o.preventDefault();
						if(!e.closest(".additional").length ) {
							e.click().closest("li").parent().next().find(".addOrderField").focus();
						}
						e.click().closest(".itemWrapper").focus();
						setTimeout(function () {
							e.click().closest("li").next().find("input").focus();
						}, 100);						
						e.closest("body").addClass("focus-sku-in").removeClass("focus-qty-in");						
					}
				}
			});
		});		
		$('.sku.ui-autocomplete-input').each(function() {
			var e = $(this);
			e.on({
				"keydown":function(o) {
					if (o.keyCode===9 || o.keyCode===13 || o.keyCode===32) {
						o.preventDefault();
						setTimeout(function () {
							$("body").removeClass("focus-sku-in").addClass("focus-qty-in");
						}, 100);						
						if (e.val() === '') {
							e.click().parentsUntil("#quickOrderWrapper").find(".addToCart").focus();
						}					
					}
				}
			});
		});	
		
    });

    $(window).load(function () {
        equalheight('.cardSlider-slide .cardSlider-heading');
        equalheight('.my-account-bill-shipping-wrap .panel-default');
        equalheight('.container .roc-form-wrapper');
        equalheight('.itemWrapper .productBrand');
        equalheight('#hawkitemlist .itemWrapper .itemImageWrapper');
        equalheight('#hawkitemlist .itemWrapper .itemTitle .itemLink');
        equalheight('#hawkitemlist .itemWrapper .item-brand-id-wrapper');
        equalheight('#hawkitemlist .itemWrapper .itemAction');
    });

    $(window).resize(function () {
        equalheight('.cardSlider-slide .cardSlider-heading');
        equalheight('.my-account-bill-shipping-wrap .panel-default');
        equalheight('.container .roc-form-wrapper');
        equalheight('.itemWrapper .productBrand');
        equalheight('#hawkitemlist .itemWrapper .itemImageWrapper');
        equalheight('#hawkitemlist .itemWrapper .itemTitle .itemLink');
        equalheight('#hawkitemlist .itemWrapper .item-brand-id-wrapper');
        equalheight('#hawkitemlist .itemWrapper .itemAction');
    });

    window.addEventListener("orientationchange", function () {
        //alert("the orientation of the device is now " + screen.orientation.angle);
        equalheight('.container .roc-form-wrapper');
    });

    // Click equal height
    $(".roc-form-wrapper .btn").each(function () {
        $(this).on({
            click: function () {
                setTimeout(function () {
                    equalheight('.container .roc-form-wrapper');
                }, 500);
            }
        });
    });


    $(document).ready(function () {
//		$('.qtyTextBox').each(function() {
//			var e = $(this);
//			e.on({
//				"keydown":function(o) {
//					if (o.keyCode===13 || o.keyCode===32) {
//						o.preventDefault();
//						e.click().closest("li").next().find("input").focus();
//						e.closest("body").addClass("input-focus-in");
//					}
//				}
//			});
//		});
//		$('.sku.ui-autocomplete-input').each(function() {
//			var e = $(this);
//			e.on({
//				"keydown":function(o) {
//					if (o.keyCode===9 || o.keyCode===13 || o.keyCode===32) {
//						o.preventDefault();
//						$("body").addClass("input-focus-in");						
//					}
//				}
//			});
//		});		
        setTimeout(function () {
            $(".my-account-bill-shipping-wrap:has(div.col-sm-6+div.col-sm-6 .panel)").addClass("yes-default-address");
            $(".my-account-bill-shipping-wrap").not(":has(div.col-sm-6+div.col-sm-6 .panel)").addClass("no-default-address");
        }, 100);       
    });

    // MatchHeight.js
    $(window).bind("load", function () {
        equalheight(".my-account-bill-shipping-wrap .panel");

    });
    $(window).resize(function () {
        equalheight(".my-account-bill-shipping-wrap .panel");
    });

});
